
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/spaces",
      function () {
        return require("private-next-pages/workspace-management/spaces.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/spaces"])
      });
    }
  